import { classNames } from "@/react/helpers/twMergeWithCN";
import { useHelpWidgetContext } from "../context/HelpWidgetContext";
import { ConversationsListPage } from "../pages/ConversationsListPage";

interface ConversationLayoutProps {
  children: React.ReactNode;
}

export const ConversationLayout = ({ children }: ConversationLayoutProps) => {
  const { isExpanded, isSidebarOpen } = useHelpWidgetContext();

  return (
    <div className="scrollbar-hide flex h-full flex-col overflow-y-auto">
      <div className="flex h-full w-full">
        {isExpanded && (
          <div
            className={classNames(
              "border-r transition-all duration-300 ease-in-out",
              {
                "w-[392px]": isSidebarOpen,
                "w-0 opacity-0": !isSidebarOpen,
              },
            )}
          >
            <div className="h-full overflow-y-auto">
              <ConversationsListPage />
            </div>
          </div>
        )}
        <div
          className={classNames(
            "flex-1 transition-all duration-200 ease-in-out",
            {
              "w-[calc(100%-392px)]": isSidebarOpen && isExpanded,
              "w-full": !isSidebarOpen,
            },
          )}
        >
          <div className="scrollbar-hide h-full overflow-y-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
